module.exports = __webpack_public_path__ + "static/media/15.79ae3050.png";